import { environment } from '../../environments/environment';
import { ActionPlanModel, Inspection } from '../shared/models';

export class BasePlugin {
  constructor() {}

  public plugin: any;
  public inspection: Inspection | ActionPlanModel;

  public isManager = environment.isManager;
  public appRoute: string = environment.applicationRoute;
  public inspectionsRoute = `/${this.appRoute}/inspections`;
  public actionPlansRoute = `/${this.appRoute}/actionplans`;
  public templatesRoute: string = '/' + this.appRoute + '/templates';
  public showPluginHelp: Boolean = false;
  public showBreadcrumbs: Boolean = false;
  public showValidations: Boolean = false;
  public showContent: Boolean = false;
  public messages: Array<string>;
  public showHidePluginHelp() {
    this.showPluginHelp = !this.showPluginHelp;
  }

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    this.plugin = plugin;
    this.inspection = inspection;
    this.showBreadcrumbs = showBreadcrumbs;
    this.showContent = showContent;
    this.showValidations = showValidations;
    this.messages = messages;
  }

  get isConfigEmpty() {
    return !this.plugin?.config || Object.keys(this.plugin?.config).length === 0;
  }

  get showHelpButton() {
    return this.showContent && this.plugin?.description;
  }
}
